module.exports = __webpack_public_path__ + "img/icon-merck.f899351b.svg";